import React, {useState} from 'react';
import DOMPurify from 'dompurify';
import toast from 'react-hot-toast';

export function Case2({immat, onNext, onPrevious, formData}) {
    const [no_immatriculation, setImmatriculation] = useState(immat);

    const validateImmat = (immatriculation) => {
        let pattern;

        if (immatriculation.substring(0, 1).match('^[0-9]+$')) {
            pattern = '^\\d{4}\\s?[A-Z]{2,3}\\s?\\d{2}$'; // Ancienne plaque
        } else {
            pattern = '^[A-Z]{2}-?[0-9]{3}-?[A-Z]{2}$'; // Nouvelle plaque
        }

        return new RegExp(pattern).test(immatriculation);
    };

    const handleInputChange = (e) => {
        const value = DOMPurify.sanitize(e.target.value);
        setImmatriculation(value);

        if (!validateImmat(value)) {
            toast.error('La plaque d\'immatriculation est invalide');
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateImmat(no_immatriculation)) {
            return;
        }
        onNext({no_immatriculation});
    };

    return (
        <div className="texte">
            <h5 className="centered"><b>Etape 1/3</b></h5>
            <hr/>
            <div className="centered">
                <h5><b>Votre immatriculation</b></h5>
            </div>
            <span>Si l'immatriculation ci-dessous n'est pas correcte, veuillez indiquer la bonne immatriculation.</span>
            <p><i>* champs obligatoire</i></p>
            <div>
                <input type="text" className="form-control"
                       value={formData.no_immatriculation ? formData.no_immatriculation : no_immatriculation}
                       onChange={handleInputChange}/>
            </div>

            <div className="app-buttons">
                <button className="buttons-secondaire" onClick={onPrevious}>Retour</button>
                <button className="buttons-primaire" onClick={handleSubmit}>Suivant</button>
            </div>
        </div>
    );
}
